import axios from "axios";
import { API_STATUS } from "./constants";
const apiConfig = process.env.REACT_APP_API_CONFIG;

export const getDetails = async (id, value) => {
    try {
        let path = "";
        if (value === "bol") {
            path = `/bol/id/${id}`;
        } else if (value === "pa") {
            path = `/pa/id/${id}`;
        } else if (value === "da") {
            path = `/da/id/${id}`;
        } else if (value === "pod") {
            path = `/pod/id/${id}`;
        }
        const response = await axios.get(apiConfig + path);
        return response;
    } catch (error) {
        return "id is not defined";
    }
};

export const searchDetails = async (id, value) => {
    try {
        let path = `/bol/number/${id}`;
        const response = await axios.get(apiConfig + path);
        return response;
    } catch (error) {
        return {
            status: 404,
            description: `BOL number ${id} not found`,
        };
    }
};

export const saveDetails = async (id, value, params) => {
    try {
        let path = "";
        if (value === "bol") {
            path = `/bol/id/${id}`;
        } else if (value === "pa") {
            path = `/pa/id/${id}`;
        } else if (value === "da") {
            path = `/da/id/${id}`;
        } else if (value === "pod") {
            path = `/pod/id/${id}`;
        }
        const response = await axios.post(apiConfig + path, params);
        return response;
    } catch (error) {
        return "number is not defined";
    }
};
